var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from "classnames";
var TextArea = function (props) {
    var _a, _b;
    var _c = props.variant, variant = _c === void 0 ? "outline" : _c, _d = props.disabled, disabled = _d === void 0 ? false : _d, _e = props.placeholder, placeholder = _e === void 0 ? "" : _e, children = props.children, _f = props.error, error = _f === void 0 ? false : _f, _g = props.className, className = _g === void 0 ? "" : _g, restProps = __rest(props, ["variant", "disabled", "placeholder", "children", "error", "className"]);
    return (_jsx("div", { children: _jsxs("div", __assign({ tabIndex: 0, className: cn("flex py-2 pr-2 space-x-2", (_a = {}, _a["border rounded"] = variant === "outline", _a["border-b-error-500 focus-within:border-b-error-500 rounded-b-none"] = error, _a["border-b rounded-t bg-surface-100"] = variant === "flat", _a["px-2"] = !children, _a["focus-within:border-x-surface-600 focus-within:border-t-surface-600 "] = !disabled && error, _a["focus-within:border-surface-600 "] = !disabled && !error, _a)) }, { children: [_jsx("textarea", __assign({ className: cn("resize-none block w-full text-base overflow-y-auto outline-none ", (_b = {},
                        _b["bg-surface-100"] = variant === "flat",
                        _b["pl-2"] = children,
                        _b["text-surface-300 pointer-events-none placeholder:text-surface-300"] = disabled,
                        _b)), placeholder: placeholder }, restProps)), children] })) }));
};
var RightElement = function (props) {
    var children = props.children, className = props.className;
    return (_jsx("div", __assign({ className: cn(" flex justify-center pointer-events-none order-last", className) }, { children: children })));
};
var LeftElement = function (props) {
    var children = props.children, className = props.className;
    return (_jsx("div", __assign({ className: cn(" flex justify-center pointer-events-none order-first", className) }, { children: children })));
};
TextArea.RightElement = RightElement;
TextArea.LeftElement = LeftElement;
export default TextArea;
//# sourceMappingURL=TextArea.js.map